import { Checkbox } from "@material-ui/core";
import {
  CheckBoxContainer,
  CheckboxText,
  Column,
  InvoiceBackdrop,
  InvoicePanel,
  Row,
} from "./customerSettings.styled";
import { ButtonStyled } from "components/buttons/buttons.styled";
import { Color } from "config/colors";
import { ZIndex } from "config/zIndex";
import { Text } from "components/Typography/text.styled";
import { TextInput } from "components/form/inputs/inputs.styled";
import { useState } from "react";
import { CompanyCustomerProduct, CustomerProductType } from "model/Company";
import { FontFamily } from "config/font";
import { useTranslation } from "react-i18next";
import { DatePickerWithLabel } from "../../general/datePickerWithLabel/datePickerWithLabel.component";

type Props = {
  customerId?: string;
  customer: any;
  setShowAddCustomerProductForm: React.Dispatch<React.SetStateAction<boolean>>;
  showAddCustomerServiceForm: boolean;
  saveProduct(product: CompanyCustomerProduct): void;
};

export const AddCustomerServiceForm: React.FC<Props> = ({
  setShowAddCustomerProductForm,
  showAddCustomerServiceForm,
  saveProduct,
  customer,
}) => {
  const { t } = useTranslation();
  const [price, setPrice] = useState("");
  const [overTimeRate, setOverTimeRate] = useState("");
  const [title, setTitle] = useState("");
  const [serviceType, setServiceType] = useState("Hourly");
  const [comment, setComment] = useState("");
  const [startDate, setStartDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();
  const [datesShouldBeSet, setDatesShouldBeSet] = useState<boolean>(false);

  const onClose = () => {
    setShowAddCustomerProductForm(false);
  };

  return (
    <>
      <InvoiceBackdrop
        open={showAddCustomerServiceForm}
        $zIndex={ZIndex.sidePanel + 1}
        onClick={onClose}
      />
      <InvoicePanel
        open={showAddCustomerServiceForm}
        $zIndex={ZIndex.sidePanel + 1}
      >
        <Row>
          <Column>
            <Text
              style={{
                fontFamily: FontFamily.MontserratSemiBold,
                fontSize: "1.5rem",
              }}
            >
              {t("CompanyCustomers.AddProduct")}
            </Text>
          </Column>
          <Column style={{ alignItems: "flex-end" }}>
            <Text
              style={{ cursor: "pointer", fontSize: "1.2rem" }}
              onClick={onClose}
            >
              ✕
            </Text>
          </Column>
        </Row>

        <Row>
          <Column>
            <Text>{t("CompanyCustomers.Title")}</Text>
            <TextInput onChange={(e) => setTitle(e.target.value)} />
          </Column>
        </Row>
        <Row>
          <Column>
            <Text>{t("CompanyCustomers.Price")}</Text>
            <TextInput
              type="number"
              onChange={(e) => setPrice(e.target.value)}
            />
          </Column>
        </Row>

        <Row>
          <Column>
            <CheckBoxContainer>
              <CheckboxText>
                {t("CompanyCustomers.SetDateForProduct")}
              </CheckboxText>
              <Checkbox
                checked={datesShouldBeSet}
                onChange={() => setDatesShouldBeSet(!datesShouldBeSet)}
              />
            </CheckBoxContainer>
          </Column>
        </Row>
        {datesShouldBeSet && (
          <>
            <Row>
              <Column>
                <Text>{t("CompanyCustomers.StartDate")}</Text>
                <DatePickerWithLabel
                  label={t("CompanyCustomers.StartDate")}
                  required
                  value={startDate}
                  onChange={(date) => {
                    if (date) {
                      let sDate = new Date(
                        date.getFullYear(),
                        date.getMonth(),
                        date.getDate(),
                      );
                      setStartDate(sDate);
                    }
                  }}
                  dateFormat="YYYY-MM-DD"
                />
              </Column>
              <Column>
                <Text>{t("CompanyCustomers.EndDate")}</Text>
                <DatePickerWithLabel
                  label={t("CompanyCustomers.EndDate")}
                  required
                  value={endDate}
                  onChange={(date) => {
                    if (date) {
                      let eDate = new Date(
                        date.getFullYear(),
                        date.getMonth(),
                        date.getDate(),
                      );
                      eDate.setHours(23, 59);
                      setEndDate(eDate);
                    }
                  }}
                  dateFormat="YYYY-MM-DD"
                />
              </Column>
            </Row>
          </>
        )}
        <Row>
          <Column>
            <Text>{t("CompanyCustomers.Comment")}</Text>
            <TextInput onChange={(e) => setComment(e.target.value)} />
          </Column>
        </Row>

        <Row style={{ marginTop: 20 }}>
          <Column>
            <ButtonStyled
              fullWidth
              backgroundColor={Color.MidnightBlue}
              onClick={onClose}
            >
              {t("General.Close")}
            </ButtonStyled>
          </Column>
          <Column>
            <ButtonStyled
              disabled={!price || !title || !serviceType}
              fullWidth
              backgroundColor={Color.BurntSienna}
              onClick={() => {
                var product: CompanyCustomerProduct = {
                  agreementId: customer.agreements[0].id,
                  title: title,
                  price: +price,
                  overtimeRate: +overTimeRate,
                  productType:
                    serviceType === "Hourly"
                      ? CustomerProductType.HOURLY
                      : CustomerProductType.FIXED,
                  comment: comment,
                };
                if (datesShouldBeSet) {
                  startDate?.setHours(3);
                  product.startDate = startDate;
                  product.endDate = endDate;
                }
                saveProduct(product);
                setShowAddCustomerProductForm(false);
              }}
            >
              {t("General.Save")}
            </ButtonStyled>
          </Column>
        </Row>
      </InvoicePanel>
    </>
  );
};
